import React from "react";
import {
  Building2,
  Cog,
  Zap,
  Cpu,
  Code2,
  Network,
  Car,
  FlaskConical,
  Factory,
  Shirt,
  ArrowRight,
  Fuel,
  BrainCircuit,
} from "lucide-react";

function AllBranches() {
  const branches = [
    {
      icon: Building2,
      title: "Civil Engineering",
      desc: "Work on real construction projects and learn practical site skills.",
    },
    {
      icon: Cog,
      title: "Mechanical Engineering",
      desc: "Work with innovative machines, tools & manufacturing technologies.",
    },
    {
      icon: Zap,
      title: "Electrical Engineering",
      desc: "Gain hands-on experience in electrical systems & automation.",
    },
    {
      icon: Cpu,
      title: "Electronics Engineering",
      desc: "Explore electronics circuits, PCB design & embedded systems.",
    },
    {
      icon: Code2,
      title: "Computer Engineering",
      desc: "Work on software, web technologies & emerging technologies.",
    },
    {
      icon: Network,
      title: "Information Technology",
      desc: "Explore IT infrastructure, networking & system management.",
    },
    {
      icon: Car,
      title: "Automobile Engineering",
      desc: "Learn automotive systems, diagnostics & vehicle technologies.",
    },
    {
      icon: FlaskConical,
      title: "Chemical Engineering",
      desc: "Work on chemical processes, plant operations & safety.",
    },
    {
      icon: Fuel,
      title: "Petroleum Engineering",
      desc: "Learn oil & gas exploration, drilling operations, refinery processes and energy technologies.",
    },
    {
      icon: BrainCircuit,
      title: "Artificial Intelligence",
      desc: "Build AI applications, machine learning models, data analytics and intelligent automation systems.",
    },
  ];

  return (
    <section className="relative bg-white dark:bg-[#050505] py-16 px-6 lg:px-16 overflow-hidden">
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/20 blur-[140px] rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/20 blur-[140px] rounded-full"></div>

      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:70px_70px]"></div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-3xl md:text-4xl font-bold  text-gray-900 dark:text-white">
            Explore Internships By <span className="text-primary">Branch</span>
          </p>
          <div className="w-20 h-1 bg-primary mx-auto mt-2 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {branches.map((item, index) => {
            const Icon = item.icon;

            return (
              <div
                key={index}
                className="group rounded-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 p-5 text-center shadow-sm hover:shadow-[0_0_35px_rgba(254,120,83,0.18)] hover:-translate-y-1 transition-all duration-300"
              >
                <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-all duration-300">
                  <Icon className="w-6 h-6" />
                </div>

                <h3 className="text-sm font-bold text-gray-900 dark:text-white">
                  {item.title}
                </h3>

                <p className="mt-2 text-xs leading-relaxed text-gray-500 dark:text-gray-300">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default AllBranches;
